var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4",attrs:{"flat":""}},[_c('v-card-text',[_c('p',{staticClass:"text-h6 text--primary mb-6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.itemList,"hide-default-footer":true,"loading":_vm.isExporting,"items-per-page":_vm.itemList.length}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }